import React from 'react'
import styled from './ProgramLearn.module.scss'

const Level = ({title}) => {
    return <div className={styled.levelCourse}>
        {title}
    </div>
}

export default Level